import { useState, useRef } from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Popover from '@mui/material/Popover';
import InputAdornment from '@mui/material/InputAdornment';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { ListItemText } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSearch } from '@fortawesome/free-solid-svg-icons';

// import testResults from './testdata.json'


const POISearch = ({ map, viewbox, setSearchMarker, setTowerFilters }) => {
  const [value, setValue] = useState('');
  const [searchItems, setSearchItems] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [busy, setBusy] = useState(false);

  const textRef = useRef('')
  const url = 'https://nominatim.openstreetmap.org/search.php?format=jsonv2&bounded=1&accept-language=en-US&countrycodes=us'

  const handleChange = (event) => {
    if (anchorEl === null) setAnchorEl(event.target);
    setValue(event.target.value);
  };

  const handleClose = () => {
    setSearchItems([]);
  };

  const handleClear = () => {
    setValue('');
    setSearchItems([]);
    setSearchMarker(null);
    map.flyToBounds([[viewbox[1], viewbox[0]], [viewbox[3], viewbox[2]]]);
  };

  const handleClick = (item) => {
    setValue(item['display_name']);
    setSearchItems([]);
    setSearchMarker([item.lat, item.lon]);
    const bounds = [[item.boundingbox[0], item.boundingbox[2]], [item.boundingbox[1], item.boundingbox[3]]]
    map.flyToBounds(bounds, { maxZoom: 11 });
    setTimeout(() => {
      textRef.current.blur();
    }, "100")
  }

  const handleSubmit = (event) => {
    setAnchorEl(textRef.current);
    setBusy(true);
    fetch(`${url}&q=${value}&viewbox=${viewbox[0]}%2C${viewbox[1]}%2C${viewbox[2]}%2C${viewbox[3]}`)
      .then(res => res.json())
      .then(
        (results) => {
          results.forEach(result => {
            if (result.display_name.indexOf('CAL Fire') > 0) {
              const nameArr = result.display_name.split(', ');
              const newNameArr = nameArr.filter((obj) => obj.indexOf('CAL Fire') === -1);
              result.display_name = newNameArr.join(', ');
            }
          })
          setSearchItems(results);
          setBusy(false);
        },
        (error) => {
          console.log(error);
          setBusy(false);
          // setSearchItems(testResults);
        }
      )
  };

  return (


    <FormControl sx={{ m: 1, width: '100%', background: 'whitesmoke' }} size="small">

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={busy}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <TextField
        inputRef={textRef}
        id='SearchBox'
        size='small'
        label="Where"
        value={value}
        onChange={handleChange}
        InputProps={{
          endAdornment: <InputAdornment position="end">
            {Boolean(value) &&
              <IconButton
                aria-label="clear results"
                onClick={handleClear}
                edge="end"
              >
                <FontAwesomeIcon icon={faTimes} size="xs" className="faTimes" />
              </IconButton>
            }

            <IconButton
              sx={{ ml: '15px' }}
              aria-label="search"
              onClick={handleSubmit}
              edge="end"
            >
              <FontAwesomeIcon icon={faSearch} size="xs" />
            </IconButton>

          </InputAdornment>
        }}
        onKeyUp={(event) => {
          if (event.key === 'Enter') {
            handleSubmit(event);
            event.stopPropagation();
          }
        }}
        sx={{
          "& .MuiInputBase-input": {
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        }}
      />

      <Popover
        open={searchItems.length > 0 ? true : false}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List dense={true}>
          {searchItems.map((item, index) => {
            return (
              <ListItem onClick={() => handleClick(item)} style={index % 2 ? { background: "#F8F8F8", maxWidth: 800 } : { background: "none", maxWidth: 800 }} key={item.place_id} {...item}>
                <ListItemText sx={{ margin: '0px' }} primary={item['display_name']}
                  primaryTypographyProps={{ style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }}
                  secondary={item['category'].replaceAll('_', ' ') + " - " + item['type'].replaceAll('_', ' ')} />
              </ListItem>
            )
          })}
        </List>
      </Popover>
    </FormControl>
  );
}

export default POISearch;